'use client';

import { IconCloudUpload } from '@tabler/icons-react';
import { Notification } from '@mantine/core';
import { useDeploymentToasts } from '@/src/lib/hooks/useDeploymentToasts';

export default function DeploymentToasts() {
  const toasts = useDeploymentToasts();

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 9999,
      }}
    >
      {toasts.map((toast) => (
        <Notification
          key={toast.id}
          title="Déploiement en cours"
          icon={<IconCloudUpload size={18} />}
          color="blue"
          withCloseButton={false}
          radius="md"
        >
          {toast.label}
        </Notification>
      ))}
    </div>
  );
}
